import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { Emdash } from "~/components/Punctuation";
import { AssetColumns } from "~/modules/assets/types";
import { getMeasureValue } from "~/utils/getMeasureValue";
import { DataGridNumberPercentChangeComboCell } from "~/components/DataGrid/DataGridNumberPercentChangeComboCell";
import { DataGridDollarPercentChangeComboCell } from "~/components/DataGrid/DataGridDollarPercentChangeComboCell";
import { AssetTableRowData } from "../types";
import { CatalogMetricSlugs } from "~/modules/catalog/types";

// // // //

export const DAILY_YIELD_DISTRIBUTED_DOLLAR_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.dailyYieldDistributedDollar,
    label: "Daily Yield Distributed",
    tooltip: CatalogMetricSlugs.daily_yield_distributed_dollar,
    type: ColumnTypes.number,
    sortsOn: AssetColumns.dailyYieldDistributedDollar,
    width: 200,
    render: (item) => {
        const measure = getMeasureValue(item, "daily_yield_distributed_dollar");

        if (measure === null) {
            return <Emdash />;
        }

        return (
            <DataGridDollarPercentChangeComboCell
                value={measure.val}
                pct_change_interval="7d"
                pct_change_value={measure.chg_30d_pct}
            />
        );
    },
};

export const DAILY_YIELD_RATE_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.dailyYieldRate,
    label: "Daily Yield Rate",
    tooltip: CatalogMetricSlugs.daily_yield_rate,
    type: ColumnTypes.percent,
    sortsOn: AssetColumns.dailyYieldRate,
    width: 150,
    render: (item) => {
        const measure = getMeasureValue(item, "daily_yield_rate");

        if (measure === null) {
            return <Emdash />;
        }

        return (
            <DataGridNumberPercentChangeComboCell
                value={measure.val / 100}
                pct_change_interval="7d"
                pct_change_value={measure.chg_7d_pct}
                type="percent"
            />
        );
    },
};
